"use strict";


Shopify.theme.jsPeopleSlideshow = {
    init: function init($section) {
        // Add settings from schema to current object
        Shopify.theme.jsPeopleSlideshow = $.extend(this, Shopify.theme.getSectionData($section));

        this.createSlider();
    },
    createSlider: function createSlider() {
        //var peopleSlidershowSlider = $('.people-slideshow.layout--slider .slider-gallery');
        var mySwiper = new Swiper('.people-slideshow.layout--slider .swiper-container.image-slider', {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            grabCursor: true,
            spaceBetween: 10,
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button.next',
                prevEl: '.swiper-button.previous',
            },
            breakpoints: {
                // when window width is >= 480px
                250: {
                    slidesPerView: 1,
                    centeredSlides: true
                },
                481: {
                    slidesPerView: 2,
                    centeredSlides: false
                },
                670: {
                    slidesPerView: 3,
                    centeredSlides: false
                },
                956: {
                    slidesPerView: 4
                },
                1440: {
                    slidesPerView: 5
                }
            }
        });
        var mySwiperSecond = new Swiper('.people-slideshow.layout--slider .swiper-container.text-slider', {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            grabCursor: true,
            effect: "fade",
            fadeEffect: { crossFade: true }

        });
        mySwiper.controller.control = mySwiperSecond;
        mySwiperSecond.controller.control = mySwiper;



/*
        var slideData = {
            blocks_per_slide: $(window).width() < 1440 ? this.blocks_per_row : 5,
            blocks_limit: this.blocks_limit,
            cellAlign: "left",
            wrapAround: true
        };
        $(peopleSlidershowSlider).flickity({
            lazyLoad: 2,
            freeScroll: false,
            imagesLoaded: true,
            draggable: true,
            cellAlign: $(window).width() < 480 ? 'center' : 'left',
            wrapAround: slideData.wrapAround,
            pageDots: false,
            contain: true,
            prevNextButtons: slideData.blocks_limit > slideData.blocks_per_slide ? true : false,
            initialIndex: 0,
            arrowShape: arrowShape,
            on: {
                ready: function ready() {
                    // Reset layout to avoid collapsing issues
                    setTimeout(function () {
                        $(peopleSlidershowSlider).flickity('resize');
                    }, 500);
                },
                dragMove: function dragMove(){
                    if($(window).width() <= 480) {
                        $(peopleSlidershowSlider).find('.thumbnail__caption').css({'transform': 'translateX(0%)'});
                    }
                },
                dragStart: function dragStart(){
                    if($(window).width() <= 480) {
                        $(peopleSlidershowSlider).find('.thumbnail__caption').css({'opacity': '0'});
                    }
                },
                dragEnd: function dragEnd(){
                    if($(window).width() <= 480) {
                        $(peopleSlidershowSlider).find('.is-selected .thumbnail__caption').css({'opacity': '1'});
                    }
                }
            }
        });*/
    },
    unload: function unload($section) {
        /*var $slider = $section.find('.flickity-enabled');
        $slider.flickity('destroy');*/
    }
};